var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavOpenTerm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3251 14.9973H0.677858C0.306648 14.9973 0.00292969 14.6936 0.00292969 14.3224C0.00292969 13.9512 0.306648 13.6475 0.677858 13.6475H14.3251C14.6964 13.6475 15.0001 13.9512 15.0001 14.3224C15.0001 14.6936 14.6964 14.9973 14.3251 14.9973Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.677614 14.9971C0.306403 14.9971 0.00268555 14.6934 0.00268555 14.3222V0.674929C0.00268555 0.303718 0.306403 0 0.677614 0C1.04883 0 1.35254 0.303718 1.35254 0.674929V14.3222C1.35254 14.6934 1.04883 14.9971 0.677614 14.9971Z",
    fill: "CurrentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00259 12.6892C0.690775 12.7 0.401834 12.4699 0.360269 12.1713C0.317665 11.8426 0.556735 11.5342 0.898694 11.4924C1.02342 11.4881 7.80573 9.88346 10.7799 1.70728C10.9888 1.42995 11.362 1.38701 11.6488 1.55714C11.9367 1.75724 11.9804 2.11586 11.8026 2.39211C8.5 10.9998 1.18968 12.6827 1.06495 12.6871C1.03377 12.6881 1.03377 12.6881 1.00259 12.6892Z",
    fill: "CurrentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8184 2.34124L8.28319 3.57963C7.93286 3.70235 7.54581 3.51612 7.42308 3.16579C7.30036 2.81545 7.48659 2.4284 7.83693 2.30568L11.3722 1.06729C11.7225 0.944566 12.1095 1.1308 12.2323 1.48113C12.355 1.83147 12.1688 2.21852 11.8184 2.34124Z",
    fill: "CurrentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0567 5.87657C12.7064 5.9993 12.3194 5.81307 12.1966 5.46273L10.9582 1.9275C10.8355 1.57717 11.0217 1.19012 11.3721 1.06739C11.7224 0.944672 12.1095 1.1309 12.2322 1.48124L13.4706 5.01646C13.5933 5.3668 13.4071 5.75385 13.0567 5.87657Z",
    fill: "CurrentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavOpenTerm);
export default __webpack_public_path__ + "static/media/icon-nav-open-term.54b3b244091a8e1584e3c6f15f0db44f.svg";
export { ForwardRef as ReactComponent };